<template>
  <nav-menu-category name="Invitations / RSVPs" fragment="invitations" :icon="iconPathCardsInvitation" v-bind="$attrs" v-on="$listeners" />
</template>


<script>
import NavMenuCategory from '@/components/NavMenuCategory.vue';
import iconPathCardsInvitation from 'raw-loader!@/assets/icon-path-cards-invitation.txt';

export default {
  name: 'nav-menu-invitations',
  components: { NavMenuCategory },
  created() {
    Object.assign(this, { iconPathCardsInvitation });
  }
}
</script>
